/**
 * Globals namespace
 * @type {Object}
 */
var globals = globals || {};
var westcon = westcon || {};

/**
 * CSRF Token Variable
 */
var CSRFToken = CSRFToken || '';
var CSRF = 'CSRFToken=' + CSRFToken;

/**
* Site content path
*/
var sitePath = sitePath || '';

/**
 * Session timeout
 */
var sessionTimeOut = sessionTimeOut || '';

/**
 * Backbone globals
 */
westcon.views = westcon.views || {};
westcon.models = westcon.models || {};
westcon.collections = westcon.collections || {};
westcon.routers = westcon.routers || {};

/**
 * Define Event Aggregator
 */
globals.eventAgg = _.extend({}, Backbone.Events);

/**
 * Define Backbone View Globals
 */
Backbone.setGlobals({
    // Set View Globals
    View: {
        eventAgg: globals.eventAgg
    }
});

/**
 * This is a reference to the original `sync` method. We need this when we override the method later.
 * @type {Function}
 */
Backbone.baseSync = Backbone.sync;

/**
 * Override default sync() to append CSRF toke to requests
 * @param {string} method
 * @param {Object} model
 * @param {Object} options
 * @returns {*}
 */
Backbone.sync = function (method, model, options) {
    'use strict';
    options = options || {};

    // If the AJAX request have be a POST...
    if (_.contains(['create', 'update', 'delete'], method) || (options.type || '').toLowerCase() === 'post') {

        // ... add CSRF token to the URL of the request.
        // It could be the manually set URL in the options of the internal URL of the model/collection.
        options.url = (_.result(options, 'url') || _.result(model, 'url'));

        // If the URL already contains some URL parameter CSRF should be concatenated with an `&` instead of `?`
        options.url += (_.contains(options.url, '?') ? '&' : '?') + CSRF;
    }

    return Backbone.baseSync.apply(this, [method, model, options]);
};

westcon.modalInQueue = 0;

westcon.modalInTransition = $.Deferred();

westcon.amQuoteDetailPendingAjaxCall = $.Deferred();

/**
 * Define Underscore.js Mixins
 */
_.mixin({
    isBlank:
    /**
     * This function is for use in the Underscore template as a null value check.
     * @param {string} string - This must be a string value, so we use _.isNumber in the underscore template to prevent numbers from being sent to this function
     * @returns {boolean}
     */
    function (string) {
        'use strict';
        return (_.isUndefined(string) || _.isNull(string) || (string.trim().length === 0));
    }
});

_.templateSettings = {
    evaluate: /<\@(.+?)\@>/g,
    interpolate: /<\@=(.+?)\@>/g,
    escape: /<\@-(.+?)\@>/g
};

// TODO: Make all the globals attributes coming from the BE, be namespaced under `globals` this will require a system wide refactoring.
_.each($('input[type="hidden"].globals'), function (attribute) {
    'use strict';
    var $attribute = $(attribute);
    window[$attribute.attr('name')] = $attribute.val();
});

/**
 * Do not cache ajax calls, IE is not liking it.
 */
$.ajaxSetup({ cache: false });

globals.path = {
    search:  sitePath + '' + '/search?text=', // TODO: Remove initial part once BE fixes redirect issues
    quoteListingPageUrl:  '/quote/quotingquotes',
    configuratorUrl: '{configuratorEndpoint}/#/configurator?endCustomer={endUserId}&denodoId={denodoId}&requestorApp=PartnerView&ssoTokenPortal={ssoTokenPortal}&actAs={actAs}',

    api: {

        // Westcon Accelerator Store Front
        westcon: {
            history: sitePath + '/customeronboard/audittrail/{customerId}?retrieveEntries=true',
            rfqCartClearQuoteUrl:  sitePath + '/quotes/clear',
            trilliumAddressCheck: sitePath + '/quoteaddress/cart/trilliumCheck',
            trilliumAddressCheckRFQ: sitePath + '/quoteaddress/rfq/trilliumCheck',
            trilliumSearchApi: sitePath + '/quoteaddress/trilliumDynamicSearch',
            checkTrilliumAddress: sitePath + '/quoteaddress/checkTrilliumAddress',
            rfqCartApiUrl:  sitePath + '/quotes',
            rfqCartSaveUrl:  sitePath + '/quotes/saverequestforquote',
            rfqCartAddUrl:  sitePath + '/quotes',
            rnqTableSearchUrl:  sitePath + '/selfservice/quotes/search',
            rfqListingTablePaginateUrl:  sitePath + '/selfservice/loadjsonRfq',
            rfqListingTableSearchUrl:  sitePath + '/selfservice/searchRfq',
            packingSlipSearchUrl:  sitePath + '/packingslip/search',
            accountQuoteTableSearchUrl:  sitePath + '/selfservice/search',
            accountQuoteTablePaginateUrl:  sitePath + '/selfservice/loadjsonQuotes',
            orderlistingTablePaginateUrl:  sitePath + '/selfservice/loadjsonOrders',
            orderlistingTableSearchUrl:  sitePath + '/selfservice/searchOrders',
            orderPDFUrl:  sitePath + '/{urlPath}',
            requestrmaTablePaginateUrl:  sitePath + '/selfservice/loadjsonRMAOrders',
            requestrmaTableSearchUrl:  sitePath + '/selfservice/searchReturnableOrders',
            submittedrmaTablePaginateUrl:  sitePath + '/selfservice/loadjsonSubmittedRMAOrders',
            submittedrmaTableSearchUrl:  sitePath + '/selfservice/searchSubmittedRMA',
            selfServiceSubmit:  sitePath + '/selfservice/submit',
            miniCart: sitePath + '/cart/miniCart',
            updateRFQNotes: sitePath + '/quotes/updateRFQNotes',
            exportOrderList: sitePath + '/selfservice/exportOrders',
            exportQuotesList: sitePath + '/selfservice/exportQuotes',
            exportRfqList: sitePath + '/selfservice/exportRfqs',
            addAssociatedProduct: sitePath + '/addAssociatedProduct',
            exportSelectedOrder: sitePath + '/quoteDetail/downloadQuote',
            exportSelectedRfq: sitePath + '/rfqDetails/downloadRfq',

            //Customer Onboarding
            deleteAttachment: sitePath + '/customeronboard/customerForm/remove/',
            customerOnboardingTabData: sitePath + '/customeronboard/customerForm/{prospectId}',
            customerOnboardingMdmValidation: sitePath + '/customeronboard/{prospectId}/checkaccount',
            prospectIdSearch: sitePath + '/customeronboard/getprospect/',
            redirectToForm: sitePath + '/customeronboard/requestform?prospectId=',
            saveCustomerOnBoard:  sitePath + '/customeronboard/customerForm/save/',
            rejectCustomerOnBoard:  sitePath + '/customeronboard/customerForm/reject/{prospectId}',
            submitOnboardForm:  sitePath + '/customeronboard/customerForm/submit/',
            removeBankDetails: sitePath + '/customeronboard/customerForm/remove/',
            zipCodeValidation: sitePath + '/customeronboard/validateZipCode?countryIso={countryIsocode}&zipcode={zipCode}',
            getProspectStatus: sitePath + '/customeronboard/customerFormStatus?prospectId={prospectId}',

            //customer availability search
            customerAvailabilitySearchUrl:  sitePath + '/customerAvailability/search',
            searchCustomerStock: sitePath + '/customerAvailability/searchCustomerStock',
            resellerSearchUrl: sitePath + '/resellerSearch',

            // Cart page
            cartLoadData:  sitePath + '/cart/cartjson/',
            checkInactiveVendorProducts:  sitePath + '/cart/checkInactiveVendorProducts',
            cartClearAll:  sitePath + '/cart/clear',
            addToCart:  sitePath + '/cart/addToCart',
            removeCart: sitePath + '/cart/removecart',
            cartAdd:  sitePath + '/cart/add',
            addTo3PLCart:  sitePath + '/cart/addTo3PLCart',

            // Saved carts page
            savedCartsTablePaginateUrl:  sitePath + '/cart/loadjsoncartlist',

            // Save cart
            saveCartUrl:  sitePath + '/quotes/saverequestforquote',

            // Clear Quote
            clearQuote:  sitePath + '/selfservice',

            //order Status
            orderStatus: sitePath + '/orderDetail/showDeliveryStatus/{sapId}',

            // Reset password request
            resetPasswordRequest:  sitePath + '/login/pw/request?site=westcon',

            // Reset get-username request
            resetUsernameRequest:  sitePath + '/login/username/request?site=westcon',

            // Check for synnex country
            accessSynnexCountryCheckURL:  '/store/user/checkSynnexRedirection?countryIsocode={countryIsocode}',

            // Clear quote checkout
            clearQuoteCheckout:  sitePath + '/selfservice',

            // Quote to Order
            quoteToOrderUrl:  sitePath + '/quoteDetail/converttoorder',
            validateEntries:  sitePath + '/quoteDetail/{quoteId}/{versionId}/validateEntries',
            quoteToTransferUrl:  sitePath + '/quoteDetail/transferQuote',
            quoteDetailsUrl:  sitePath + '/cart/addBOM/submit',
            quoteConversionOrderStatus:  sitePath + '/converttoorder/status',
            updateQuoteLock:  sitePath + '/quoteDetail/updateQuoteLock/',
            autoSaveQuote:  sitePath + '/quoteDetail/autoSaveQuote',

            // Clear quote checkout
            viewProductAvailable:  sitePath + '/stock/detailAvailability/',

            // Shopping cart save URL
            shoppingCartSaveUrl:  sitePath + '/quotes/saverequestforquote',

            // Shopping cart save Cart Name
            shoppingCartSaveCartName:  sitePath + '/cart/saveCartName',

            // get existing saved cart list
            shoppingCartSavedCartNames:  sitePath + '/cart/populatesavedcart',

            // Shopping cart Ammend Cart Name
            shoppingCartAmmendCartName:  sitePath + '/cart/amendCart',

            //clearCart 3PL
            shoppingCartClearCart:  sitePath + '/cart/clear',

            // RMA Requests
            rmaSerialNumbers:  sitePath + '/selfservice/rma/serialNumbers',

            // Switch user account
            switchUser:  sitePath + '/switchusergroup/populateAccounts',
            populateCurrency: sitePath + '/switchusergroup/populateCurrency',

            // Zip code validation
            getAddressByZip:  sitePath + '/getaddressbyzip',

            // State validation
            getStateByCountry:  '/store/getstatebycountry',

            getCountryData:  '/store/getcountriesdata',

            getCountriesDataOnboardingForm: '/store/getCountriesDataForOnboardingForm',

            logout: '/store/logout',

            prospectLogout: sitePath + '/logout',

            // concurrent login check
            concurrentLoginCheck: sitePath + '/login/concurrentLoginCheck',
            partnerCentralLiteUserId: sitePath + '/login/validateMicrosoftADCustomer',

            // Common Path
            storefrontCommon:  sitePath + '',

            // Quote conversion
            conversionConfirmation:  sitePath + '/quoteDetail/orderconfirmation/',

            // Get state based on iso country code
            getStateList:  sitePath + '/quoteaddress/stateList',

            // Get a list of resellers for an account manager
            getResellerList:  sitePath + '/resellerSearch/findReseller',
            getResellerAccounts:  sitePath + '/resellerSearch/populateAccounts',
            switchStore:  sitePath + '/resellerSearch/switchStore',
            setCountryAndLanguage: sitePath + '/resellerSearch/setCountryAndLanguage',
            switchStoreReseller: sitePath + '/switchusergroup/switchStore',

            //Upload BOM
            uploadBom: sitePath + '/cart/addBOM',
            uploadBomStatus: sitePath + '/cart/addBOM/status',

            //Lazy load for customer price in PLP
            lazyLoadProducts:  sitePath + '/productcatalog/lazyLoadProducts',

            //Licence page URls
            licenceFetch: sitePath +  '/license/search',
            licenceDownloadHistoryFetch: sitePath +  '/license/downloadHistory',
            licenceAccessLevel: sitePath +  '/license/accessLicense',
            checkOrder: sitePath + '/license/checkSalesOrderNumber',
            exportLicenses: sitePath + '/license/exportLicenses',

            //3PL Inbound Requests
            threePLInboundRequests: sitePath +  '/3plInbound/search',
            threePLInboundRequestsExport: sitePath +  '/3plInbound/export3PLRequest',
            threePLDownloadStockURL: sitePath +  '/customerAvailability/downloadAvailability',
            threePLInboudCreatNewRequest: sitePath +  '/3plInbound',
            threePLInboudCreatNewRequestStateList: sitePath +  '/3plInbound/stateList',
            threePLInboudCreatNewRequestSave: sitePath +  '/3plInbound/save',
            threePLInboudCreatNewRequestCheckStockLoc: sitePath +  '/3plInbound/validateExistingStock?stockLoc=',
            downloadServiceDocuments: sitePath +  '/quoteDetail/serviceDocument',
            financialService: sitePath +  '/financialservice/requestFinance',
            addressMDMCheck: sitePath +  '/quoteaddress/addressMDMCheck',
            checkoutAddressMDMCheck: sitePath +  '/checkout/addressMDMCheck',
            getLatestMessageTelstraForOrder: sitePath + '/orderDetail/pushLatestMessage/',
            getLatestMessageTelstraForQuote: sitePath + '/quoteDetail/pushLatestMessage/',

            //Bss Telestra Request
            telestraInboundFIleUpload: sitePath + '/bssTelstraRequest/processTelstraBssOrderXml',
            retriggerFreshdeskTicket: sitePath + '/bssTelstraRequest/retriggerFreshdeskTicket',
            getBssOrderData: sitePath + '/bssTelstraRequest/getBssOrderData',
            generateTelstraXml: sitePath + '/bssTelstraRequest/generateTelstraXml'

        },

        // Quoting Store Front
        quoting: {
            logExecutionTime: sitePath + '/quoteDetail/logExecutionTime',
            quoteDetailsUrl: sitePath + '/products/addbombyfile/submit/{quoteId}',
            quoteVrfColBulkUpdate: sitePath + '/quoteDetail/saveBulkVrfData/{quoteId}',
            refreshTaxApi: sitePath + '/quoteDetail/refreshTax/{quoteId}',
            calculateFreightCostByEST: sitePath + '/quoteDetail/calculateFreightCostByEST/{quoteId}',
            onLoadAccountIndex: sitePath + '/quoteDetail/{quoteId}/onLoadAccountIndex',
            historyQuote: sitePath + '/quoteDetail/{quoteId}/audittrail?retrieveEntries=true',
            productAvailability: sitePath + '/quoteDetail/{quoteId}/productAvailability',
            getLatestServiceDocument: sitePath + '/quoteDetail/getLatestServiceDocument',
            linkQuoteToRfq: sitePath + '/requestforquote/linkQuote',
            quoteUpdateRebate: sitePath + '/quoteDetail/updateRebate/{quoteId}',
            ajaxQuoteSubmit: sitePath + '/quoteDetail/ajaxsubmit/{quoteNum}',
            ajaxDealIdSubmit: sitePath + '/products/addDealAjax',
            getGeoIdGroup: sitePath + '/quoteDetail/fetchGeoIdGroup/{quoteNum}',
            createNewRevision: sitePath + '/quoteDetail/createNewRevision',
            getSalesOfficeData: sitePath + '/quoteDetail/getSalesOfficeForGeoIdGroup',
            updateContactDetails: sitePath + '/quoteDetail/{quoteId}/editcontact',
            swedishChemicalTaxRecalculate: sitePath + '/quoteDetail/refreshPrices/{quoteNum}',
            performanceUrl: sitePath + '/quoteDetail/loadTime/{quoteNum}',
            fetchDealIdVendors: sitePath + '/quoteDetail/fetchDealIdVendors',
            fetchQuotePageItems: sitePath + '/quotingquotes/fetchQuotePageItems',
            getAllSalesOrgForRfq: sitePath + '/requestforquote/getAllSalesOrgForRfq',
            getAllSalesOrgForRenewals: sitePath + '/bulkrenewal/getAllSalesOrgForRenewals',
            getCopyPasteOptions: sitePath + '/quoteDetail/getCopyPasteOptions',
            saveAwsQuote: sitePath + '/quoteDetail/saveAwsOrder',
            validateAlternatePayerAddress: sitePath + '/quoteDetail/validateAlternatePayerAddress',
            fetchVatNumbers: sitePath + '/quoteDetail/fetchVatNumbers/{quoteId}',
            isBillingEventDatePast: sitePath + '/quoteDetail/isBillingEventDatePast',
            downloadDAPdfCount: sitePath + '/quoteDetail/downloadDAPdfCount',

            // Tables
            addressSearchTrillium: sitePath + '/quoteDetail/addressSearch',
            quotesTablePaginateUrl:  sitePath + '/quotingquotes/loadjson',
            getAccountManager: sitePath + '/quotingquotes/amDataList',
            fetchRenewalExecutivesQuotingQuotes: sitePath + '/quotingquotes/fetchRenewalExecutives',
            salesOfficeChange:  sitePath + '/quoteDetail/updateHeaderDetails/{quoteId}',
            updateHeaderProjectNumber:  sitePath + '/quoteDetail/projectNumber/{quoteId}',
            updateHeaderAccountManager:  sitePath + '/quoteDetail/updateHeaderItems/{quoteId}',
            retrieveLandedCost:  sitePath + '/quoteDetail/getLandedCost/{quoteId}',
            quoteAddZeroValueLines: sitePath + '/quoteDetail/addzerovaluelines/{quoteId}',
            quotesTableClearFilterUrl:  sitePath + '/quotingquotes/clearSavedFilters',
            quotesTableSearchUrl:  sitePath + '/quotingquotes/search',
            bulkRenewalTableSearchUrl:  sitePath + '/bulkrenewal/search',
            bulkRenewalSendEmailApiUrl:  sitePath + '/bulkrenewal/step3/{bulkRenewalKey}/sendQuoteEmail',
            bulkRenewalTableRemoveQuoteUrl:  sitePath + '/bulkrenewal/{bulkRenewalKey}/remove/{quoteID}',
            rfqTablePaginateUrl:  sitePath + '/requestforquote/loadjson',
            rfqTableSearchUrl:  sitePath + '/requestforquote/search',
            closeOrReopenRFQ:  sitePath + '/requestforquote/closeOrReopenRFQ',
            resellerTablePaginateUrl:  sitePath + '/quotingselectreseller/getresellers',
            resellerTableSearchUrl:  sitePath + '/quotingselectreseller/searchunits',
            resellerTableGetFavoritesUrl: sitePath + '/quotingselectreseller/getCustomerFavorities',
            checkInvalidVendorProducts: sitePath + '/quotingselectreseller/checkInvalidVendorProducts',
            saveCommentUrl: '/quoteDetail/savecomment{quoteId}',
            productTableSearchUrl:  sitePath + '/search/productSearchData',
            resellerSearchCriteriaUrl:'/quote/quotingquotes/searchreseller',
            resellerBelongingToSalesorg:'/quote/customerFavorites/searchreseller',
            getAllSalesOrg: '/quote/customerFavorites/getAllSalesOrgs',
            getSalesOrgBelongingToReseller: '/quote/customerFavorites/searchSalesOrgsByReseller',
            getSalesofficeBelongingToSalesorg: '/quote/customerFavorites/getSalesOffices',
            createFavorites: '/quote/customerFavorites/createFavorites',
            updateFavorites: '/quote/customerFavorites/updateFavorites',
            deleteFavorites: '/quote/customerFavorites/deleteFavorites',
            getSavedFavorites: '/quote/customerFavorites/getFavorites',
            searchsalesofficeUrl:'/quote/quotingquotes/searchsalesoffice',
            bulkResellerSearchUrl:'/quote/bulkrenewal/searchreseller',
            bulkResellerProjecteligibilityURL:'/quote/bulkrenewal/eligibleForProjectNoSearch',
            updateDefaultSalesOrgDetails:'/quote/quotingselectreseller/updateDefaultSalesOrgDetails',
            dynamicTabFieldsUrl: sitePath + '/quoteDetail/fetchVendorSalesInformation/{quoteId}',
            getTotalResellerPriceOfAwsLines: sitePath + '/quoteDetail/getTotalResellerPriceOfAwsLines/',

            // CRM Lookup table
            crmOpportunitySearchUrl:  sitePath + '/quoteDetail/searchOpportunities/{quoteId}',
            crmOpportunityLoadUrl:  sitePath + '/quoteDetail/opportunities/{quoteId}',
            crmOpportunityCreateNew:  sitePath + '/quoteDetail/createOpportunity',
            upsertHybrisOpportunityUrl:  sitePath + '/quoteDetail/upsertHybrisOpportunity',
            getDenodoId: sitePath + '/quoteDetail/{quoteId}/getProductFromDenodo',
            getPartnerKey:  sitePath + '/quoteDetail/{quoteId}/getPartnerKey',
            draftOrderId:  sitePath + '/quoteDetail/{quoteId}/draftOrderId',
            getRenewalExecutives: sitePath + '/quoteDetail/fetchRenewalExecutives',

            productTableAddToQuoteUrl:  sitePath + '/quoteDetail/addProductListToQuote',
            productTableAddToQuoteNewDealUrl:  sitePath + '/quoteDetail/addNewDeal',
            billingEvents:  sitePath + '/quoteDetail/billingEvents',

            renewalsSearchUrl: sitePath + '/quotingfindrenewalquote/search',
            getServicePricingUrl:  sitePath + '/quoteDetail/getServiceViewPricing',
            checkQuoteStatus: sitePath + '/quoteDetail/checkquotestatus/',

            // Quote detail page
            quotTableRenderTable:  sitePath + '/quoteDetail/showGrid/{quoteId}',
            quoteTablePartNoSearch:  sitePath + '/search/autocomplete',
            quoteTableUpdateAll:  sitePath + '/quoteDetail/updateAll/{quoteId}',
            quoteTableValidateEntries:  sitePath + '/quoteDetail/validateEntries/{quoteId}',
            quoteTableAddProductToQuote:  sitePath + '/quoteDetail/addProductToQuote/{quoteId}',
            quoteTableUpdateProduct:  sitePath + '/quoteDetail/updateGrid/{quoteId}',
            revertEmbeddedToOriginal:  sitePath + '/quoteDetail/revertEmbeddedToOriginal/{quoteId}',
            addEmbeddedToOriginal:  sitePath + '/quoteDetail/addEmbeddedToOriginal/{quoteId}',
            addServiceCrossSellToParent:  sitePath + '/quoteDetail/addServiceCrossSellToParent/{quoteId}',
            removeServiceCrossSellFromParent:  sitePath + '/quoteDetail/removeServiceCrossSellFromParent/{quoteId}',
            quoteTableDeleteProducts:  sitePath + '/quoteDetail/update/{quoteId}',
            quoteTableUpdateAllProducts:  sitePath + '/quoteDetail/updateProducts/{quoteId}',
            quoteTableGetAvailability:  sitePath + '/stock/detailAvailability/',
            quoteTableGetAvailabilityByCategory:  sitePath + '/stock/category/',
            quoteTableCheckSAPPricing:  sitePath + '/quoteDetail/validatePricing/{quoteId}',
            quoteTableCheckSAPPricingOnLoad: sitePath + '/quoteDetail/validatePricingWithExisting/',
            quoteTableUpdatePricing:  sitePath + '/quoteDetail/updateSAPPrices/{quoteId}',
            quoteTableCheckSAPTimer:  sitePath + '/quoteDetail/checkTimeElapsed/{quoteId}',
            changePrimaryQuote: sitePath + '/quoteDetail/changePrimaryQuote/{quoteId}',
            quoteTableUpdateFreight:  sitePath + '/quoteDetail/updateFreight/{quoteId}',
            quoteTableCalculateFreight: sitePath + '/quoteDetail/calculateEstimatedFreight/{quoteId}',
            quoteTableUpdateTotal: sitePath + '/quoteDetail/updateTotal/{quoteId}',
            saveHideFlag: sitePath + '/quoteDetail/saveHideFlag?',
            quoteTableDrag: sitePath + '/quoteDetail/dragAndDropRow/{quoteId}',
            creditInformation: sitePath + '/quoteDetail/getCustomerCreditBalances/{quoteId}',
            sbaSearchUrl:  sitePath + '/searchSBA',
            sbaApplyUrl:  sitePath + '/applysba',
            sbaGetUrl:  sitePath + '/getsbadetails',
            dynamicMdmSearchApi: sitePath + '/quoteaddress/searchAddress/{quoteId}',
            trilliumSearchApi: sitePath + '/quoteaddress/trilliumDynamicSearch',
            sbaAgreementInitModelUrl:sitePath + '/quoteDetail/getAllSbaSearchCriterias',
            addAssociationToQuote:sitePath + '/quoteDetail/addAssociationToQuote',
            searchSBAAgreementUrl: sitePath + '/quoteDetail/searchSbaAgreements',
            searchSBAAgreementRulesUrl: sitePath + '/quoteDetail/searchSbaAgreementRules',
            sbaGetQuoteDetails:  sitePath + '/getquotesbadetails?quoteId={quoteId}',
            saveAndClose:  sitePath + '/quoteDetail/saveAndClose',
            updateQuoteCurrency: sitePath + '/quoteDetail/updateCurrency/{quoteId}',
            addAssociatedProducts:  sitePath + '/quoteDetail/addAssociatedProductListToQuote/{quoteId}',
            addProductCategories:  sitePath + '/quoteDetail/browseVendorCategories',
            productSearchDataByVendor:  sitePath + '/search/productSearchDataByVendor',
            productSearchDataByCategory:  sitePath + '/search/productSearchDataByCategory',
            getCrmOpportunities: sitePath + '/quoteDetail/vendorOpportunities/{quoteId}',
            quoteTableSaveColumns: sitePath + '/quoteDetail/updateTableColumns/{quoteId}',
            quoteTableResetColumns: sitePath + '/quoteDetail/resetColumns/{quoteId}',
            quoteTableStatusCheck: sitePath + '/quoteDetail/create/{quoteId}/status',
            sapContactGet: sitePath + '/getcontactinformations',
            linkContactToShippingAddress: sitePath + '/quoteaddress/saveContactInformation/{quoteId}',
            sapContactGetQuote: sitePath + '/getcontactById',
            updateQuoteSalesOffice: sitePath + '/quoteDetail/updateSalesOffice/{quoteId}',
            fraudulentUrl: sitePath + '/quoteDetail/fraudulent',
            updateGlobalConfigPopup: sitePath + '/quoteDetail/updateGlobalConfigPopup/{quoteId}',
            searchContact: sitePath + '/accountContacts/searchForContacts',
            createContact: sitePath + '/accountContacts/{quoteNumber}/createcontact',
            updateContact: sitePath + '/accountContacts/{quoteNumber}/updateContact',
            searchAccounts: sitePath + '/accountContacts/{quoteNumber}/searchForAccounts',
            dynamicTrilliumSearchApi:  sitePath + '/accountContacts/searchInTrillium',
            createAccounts: sitePath + '/accountContacts/{quoteNumber}/createaccount',
            updateAccounts: sitePath + '/applyEndUser/{quoteNumber}',
            updatePayerAccount: sitePath + '/accountContacts/{quoteNumber}/updateAccount',
            trilliumAddressCheck: sitePath + '/quoteaddress/trilliumCheck/{quoteNumber}',
            validateOrderReason: sitePath + '/quoteDetail/validateAWSOrderAjax',
            sendAWSQuoteNotification: sitePath + '/quoteDetail/sendAwsNotification/{quoteNumber}',
            populateAwsInformation: sitePath + '/quoteDetail/populateAWSInformationAjax',
            refreshPrices: sitePath + '/quoteDetail/refreshPrices/{quoteNumber}',

            //salesFX rate
            quoteSalesFXRate: sitePath + '/quoteDetail/salesFXRate/{quoteId}',
            editSalesFxRate: sitePath + '/quoteDetail/editSalesFXRate/{quoteId}',

            //freightUplift
            editFreightUplift: sitePath + '/quoteDetail/editFreightUplift/{quoteId}',

            // VRF data
            vrfHeaderLevelInputData:  sitePath + '/quoteDetail/showVrfHeader/{quoteId}',
            vrfTableData:  sitePath + '/quoteDetail/showVrfData/{quoteId}',
            saveVrfHeader:  sitePath + '/quoteDetail/saveVrfHeader/{quoteId}',
            clearVrfTableData: sitePath + '/quoteDetail/{quoteId}/clearQuoteVrfData',

            // Sparing API
            spareOut: sitePath + '/quoteDetail/spareOut/{quoteId}',
            revertSparing: sitePath + '/quoteDetail/revertSparing/{quoteId}',

            // Quote Detail Page
            quoteEmailSend:  sitePath + '/quoteDetail/sendQuoteEmail',
            additionVendorQuotesOnExistingQuoteModal:  sitePath + '/quoteDetail/addAdditionalVendorQuotes',

            //Quote split order
            quoteGetSplitOrderTable: sitePath + '/quoteDetail/splitOrderTable/{quoteId}',
            quoteSplitOrderSubmit: sitePath + '/quoteDetail/splitOrderSubmit',
            quoteSplitOrderIncompletionSubmit: sitePath + '/quoteDetail/{quoteId}/quoteCleanSOSplitOrder',

            // Quote to Order
            amQuoteToOrderUrl:  sitePath + '/quoteDetail/converttoorder',
            validatePO: sitePath + '/quoteDetail/validatePO?poNumber={poNumber}',

            // download Quote
            retrieveDownloadData: sitePath + '/quoteDetail/getOutputFiles/',

            //incoterm url
            updateIncoterm:  sitePath + '/quoteDetail/updateincoterm?incoterm={incoterm}&incoterm2={incoterm2}',

            // End User search
            endUserTableSearchUrl:  sitePath + '/searchEndUser/{quoteId}',
            applyEndUserAccount:  sitePath + '/applyEndUser/{quoteId}',

            // Quote conversion
            conversionConfirmation:  sitePath + '/quoteDetail/orderconfirmation/',
            quoteConversionOrderStatus:  sitePath + '/quoteDetail/converttoorder/',

            // Quoting Common
            quotingCommon:  sitePath + '',

            // Zip code validation
            getAddressByZip:  sitePath + '/getaddressbyzip',

            // State validation
            getStateByCountry:  sitePath + '/getstatebycountry',

            // Countries data
            getCountryData: sitePath + '/getcountriesdata/{quoteId}',

            // Get state based on iso country code
            getStateList:  sitePath + '/quoteaddress/stateList',

            // Shipping form
            submitShippingForm:  sitePath + '/quoteaddress/saveshippingdetails/{quoteId}',

            // Search SAP Account
            searchSapAccount: sitePath + '/searchSapAccount',

            //Upload BOM
            uploadBom: sitePath + '/products/addbombyfile',
            uploadMultiQuote: sitePath + '/products/uploadMultiSheetQuotes',

            copyQuote:  sitePath + '/quoteDetail/copyQuote/{quoteId}/{copyQuoteOption}',
            copyQuoteStatus:  sitePath + '/quoteDetail/canCopyQuote/{quoteId}',
            saveTaxClassification:  sitePath + '/quoteDetail/{taxClassificationCode}/{quoteId}/saveTaxClassification',
            getNewTotals:  sitePath + '/quoteDetail/showTotal/{quoteId}',
            uploadBomStatus:  sitePath + '/products/addbombyfile/status',
            searchAccountManager: sitePath + '/quoteDetail/searchAccManager',
            incompletioncheck: sitePath + '/quoteDetail/{quoteId}/incompletioncheck',

            //check margin
            checkMargin:  sitePath + '/quoteDetail/totalMarginCheck/{quoteId}',

            //service documents
            checkServiceDocuments: sitePath + '/quoteDetail/getServiceProductGroups/',
            fetchServiceDocuments: sitePath + '/quoteDetail/getServiceDocuments/',
            downloadServiceDocuments: sitePath + '/quoteDetail/serviceDocument/',
            serviceDocumentsValidation: sitePath + '/quoteDetail/validateServiceDocs/{quoteId}/',

            //CISCO Anuity
            fetchConfiguratorData: sitePath + '/quoteDetail/showVpsConfigurator/{quoteId}',

            //SBAchangeRequest
            sbaChangeRequest: sitePath + '/quoteDetail/changeRequestSBA/{quoteId}',
            quoteFraudulentCheck: sitePath + '/quoteDetail/validateFraudulentCheck',
            merakiMandatoryCheck: sitePath + '/quoteDetail/merakiMandatoryCheck/{quoteNumer}',
            saveCopyVendorQuoteInput: sitePath + '/quoteDetail/saveCopyVendorQuoteInput',
            validateSalesOrg: sitePath + '/quoteDetail/validateSalesOrg/'
        },

        orderentry: {
            addressSearchTrillium: sitePath + '/order/addressSearch',
            orderVrfColBulkUpdate: sitePath + '/order/saveBulkVrfData',
            dynamicMdmSearchApi: sitePath + '/order/searchAddress/{orderNumber}',
            dynamicTrilliumSearchApi: sitePath + '/order/searchInTrillium',
            trilliumSearchApi: sitePath + '/order/trilliumDynamicSearch',
            trilliumAddressCheck: sitePath + '/order/trilliumCheck/{orderNumber}',
            getVendorList: sitePath + '/vendorquote/getVendorList',
            getCountriesData: sitePath + '/order/getcountriesdata',
            getStatesByCountry: sitePath + '/order/getstatebycountry',
            revertEmbeddedToOriginal:  sitePath + '/order/revertEmbeddedToOriginal/{orderNumber}',
            addEmbeddedToOriginal:  sitePath + '/order/addEmbeddedToOriginal/{orderNumber}',
            addServiceCrossSellToParent:  sitePath + '/order/addServiceCrossSellToParent/{orderNumber}',
            removeServiceCrossSellFromParent:  sitePath + '/order/removeServiceCrossSellFromParent/{orderNumber}',
            quoteAddZeroValueLines: sitePath + '/order/{orderNumber}/addzerovaluelines',
            setContactvalidationInSession: sitePath + '/order/setContactvalidationInSession/{orderNumber}',
            mdmAddressError: sitePath + '/order/{orderNumber}/addressValidation',
            bulkUpdateMismatch: sitePath + '/mismatch/{orderId}/bulkUpdateMissmatch',
            vrfTableBulkUpdate: sitePath + '/mismatch/{orderId}/vrfBulkUpdate',
            getMismatchData: sitePath + '/mismatch/{orderId}/getEntriesMismatch/{compareType}',
            getVrfMismatchData: sitePath + '/mismatch/{orderId}/getVRFMismatch/{compareType}',
            getVrfHeaderMismatchData: sitePath + '/mismatch/{orderId}/getHeaderVRFMismatch/{compareType}',
            getSBAMismatchData: sitePath + '/mismatch/{orderId}/getSBAMismatch/{compareType}',
            orphanEntriesMismatch: sitePath + '/mismatch/{orderId}/getOrphanEntries',
            saveOrphanEntriesMismatch: sitePath + '/mismatch/{orderId}/saveOrphanEntries?' + CSRF,
            addAssociatedProducts:  sitePath + '/quoteDetail/addAssociatedProductListToQuote',
            searchQuoteRevision: sitePath + '/dashboard/searchQuoteRevision',
            searchOrders: sitePath + '/dashboard/searchorders',
            searchOrdersCD: sitePath + '/dashboard/searchOrders/customerDispute',
            searchOrdersCdCounts: sitePath + '/dashboard/searchOrders/customerDisputeCounts',
            searchQuotes: sitePath + '/dashboard/searchquote',
            searchReseller: sitePath + '/dashboard/searchreseller',
            searchEndCustomer: sitePath + '/dashboard/searchEndCustomer',
            searchSalesOffice: sitePath + '/dashboard/salesOffice',
            validateQuoteId: sitePath + '/quote/validateQuote',
            getPartnerKey:  sitePath + '/order/{orderNumber}/getPartnerKey',
            draftOrderId:  sitePath + '/order/{orderNumber}/draftOrderId',
            searchAccounts: sitePath + '/order/${orderNumber}/searchForAccounts',
            updateAccount: sitePath + '/order/${orderNumber}/updateAccount',
            updateBlocks: sitePath + '/order/{orderNumber}/updateBlocks',
            validateFraudulentCheck: sitePath + '/order/validateFraudulentCheck',
            convertQuoteToOrder: sitePath + '/quotetoorder/submit',
            convertQuoteToOrderStatus: sitePath + '/quotetoorder/converttoorder',
            convertQuoteToOrderStatusRedirect: sitePath + '/order/',
            splitOrderTable: sitePath + '/quotetoorder/splitOrderTable',
            getOrderSbaDetails: sitePath + '/order/getordersbadetails',
            orderCopy: sitePath + '/order/{orderId}/copy',
            applySba: sitePath + '/order/applysba',
            searchSba: sitePath + '/order/searchSBA',
            sbaGetUrl:  sitePath + '/order/getsbadetails',
            autoSaveOrderData: sitePath + '/order/{orderId}/autoSave',
            showVrfData:  sitePath + '/order/showVrfData',
            showVrfHeader:  sitePath + '/order/showVrfHeader',
            saveVrfHeader: sitePath + '/order/{orderId}/saveVrfHeader',
            saveColumnOrder: sitePath + '/order/{orderId}/updateTableColumns',
            resetColumnsOrder: sitePath + '/order/{orderId}/resetColumns',
            updateTotal: sitePath + '/order/{orderId}/updateTotal',
            updateQuoteOrderSalesOffice: sitePath + '/order/updateSalesOffice/{orderNumber}',
            confirmSalesOfficeChange: sitePath + '/order/{orderNumber}/confirmSalesOfficeChange',
            validateEntries: sitePath + '/quote/validateEntries/{quoteId}/{versionId}',
            calculateFreight: sitePath + '/order/{orderId}/calculateFreight',
            saveTaxClassification: sitePath + '/order/{orderId}/{taxClassificationCode}/saveTaxClassification',
            validatePO: sitePath + '/order/{orderNumber}/validatePO?poNumber={poNumber}',
            validateCaseNumber: sitePath + '/order/{orderNumber}/updatePO?caseNumber={caseNumber}',
            unCheckEndUserBilling: sitePath + '/order/{orderNumber}/unCheckEndUserBilling',
            validateCaseRefNumber: sitePath + '/order/{orderNumber}/updateEDI?confirmationNum={confirmationNum}',
            validateQuoteNumber: sitePath + '/order/{orderNumber}/updateQuote?quoteNumber={quoteNumber}',
            contractorder: sitePath + '/contractorder/contractdetails?contractNumber={contractNumber}',
            createReference: sitePath + '/contractorder/createOrderFromReference',
            addPartsWithRef: sitePath + '/contractorder/{orderNumber}/addpartswithref',
            updatebulkref: sitePath + '/contractorder/updatebulkref',
            contractOrderCreation: sitePath + '/order/',
            fraudulentUrl: sitePath + '/order/fraudulent/{orderNumber}',
            validateSalesOrg: sitePath + '/order/validateSalesOrg/',
            orderUpdateRebate: sitePath + '/order/updateRebate/{orderId}',
            swedishChemicalTaxRecalculate: sitePath + '/order/refreshPrices/{orderId}',
            dynamicTabFieldsUrl: sitePath + '/quote/fetchVendorSalesInformation/',
            dynamicTabFieldsUrlOe: sitePath + '/order/fetchVendorSalesInformation/',
            billingEvents:  sitePath + '/order/billingEvents',
            billingEventsQuoteDetail: sitePath + '/quote/billingEvents',
            fetchVatNumbers: sitePath + '/order/fetchVatNumbers/{orderId}',

            // Sparing API
            spareOut: sitePath + '/order/spareOut/{orderId}',
            revertSparing: sitePath + '/order/revertSparing/{orderId}',
            po: {
                validateAktivir: sitePath + '/po/casenumber',
                pathToValidAktivir: sitePath + '/po/order/',
                manualOrder: sitePath + '/order/new/manual',
                searchReseller: sitePath + '/launch/searchreseller',
                createOrder: sitePath + '/po/createorder',
                checkInvalidVendorProducts: sitePath + '/order/new/checkInvalidVendorProducts'

            },
            edi: {
                validateEDI: sitePath + '/edi/confirmationNumber',
                pathToValidEDI: sitePath + '/edi/order/',
                manualOrder: sitePath + '/order/new/manual',
                searchReseller: sitePath + '/launch/searchreseller'
            },
            orderDetails: {
                getCustomerDispute: sitePath + '/order/getCustomerDispute/{orderNumber}',
                onLoadAccountIndex: sitePath + '/order/{orderId}/onLoadAccountIndex',
                show: sitePath + '/order/{orderId}/showGrid',
                orderTableAddProductToOrder:  sitePath + '/order/{orderId}/addProductToOrder',
                orderTableUpdateProduct:  sitePath + '/order/{orderId}/updateGrid',
                orderTableUpdateAllProducts: sitePath + '/order/{orderId}/updateProducts/',
                checkStatus: sitePath + '/order/create/{orderId}/status',
                productAvailability: sitePath + '/order/{orderId}/productAvailability',
                createContact: sitePath + '/order/{orderId}/createcontact',
                searchContact: sitePath + '/order/searchForContacts',
                updateContact: sitePath + '/order/{orderNumber}/updateContact',
                editContact: sitePath + '/order/{orderId}/editcontact',
                copyContacts: sitePath + '/order/{orderId}/updateContacts',
                addProductListToOrder: sitePath + '/order/{orderId}/addProductListToOrder',
                history: sitePath + '/order/{orderId}/audittrail?retrieveEntries=true',
                incompletioncheck: sitePath + '/order/{orderId}/incompletioncheck',
                updateShipDate: sitePath + '/order/{orderId}/updateheader?fieldname={fieldName}&fieldValue={fieldValue}',
                searchAccountManager: sitePath + '/order/searchAccManager',
                updateIncoterm: sitePath + '/order/{orderId}/updateincoterm?incoterm1={incoterm1}&incoterm2={incoterm2}',
                checkPoMatch: sitePath + '/order/{orderId}/checkPoMatch',
                savePoMatch: sitePath + '/order/{orderId}/savePoChanges',
                saveEdiMatch: sitePath + '/order/{orderId}/saveEdiChanges',
                saveQuoteMatch: sitePath + '/order/{orderId}/saveQuoteChanges',
                checkPoMatchFieds: sitePath + '/mismatch/{orderId}/getMatchedFields',
                checkPoMatchUpdateFieds: sitePath + '/mismatch/{orderId}/getEntryMatchedFields',
                checkEdiMatchFieds: sitePath + '/mismatch/{orderId}/getMatchedFields',
                checkHeaderMatchFieds: sitePath + '/mismatch/{orderId}/getHeaderMismatch/{compareType}?' + CSRF,
                checkHeaderEntryValue: sitePath + '/mismatch/{orderId}/getMismatchTargets',
                saveMisMatchTargets: sitePath + '/mismatch/{orderId}/saveMismatchTargets/{option}',
                checkEdiMatchUpdateFieds: sitePath + '/mismatch/{orderId}/getEntryMatchedFields',
                checkEdiMatch: sitePath + '/order/{orderId}/checkEdiMatch',
                checkQuoteMatch: sitePath + '/order/{orderId}/checkQuoteMatch',
                editCompanyName: sitePath + '/order/{orderId}/editCompanyName',
                validateEntries: sitePath + '/order/{orderId}/validateEntries',
                addAssociationToQuote: sitePath + '/order/addAssociationToOrder',
                rulesEngineAPI: sitePath + '/order/{orderId}/runRulesEngine?poNumber={poNumber}',
                rejectOrderAPI: sitePath + '/order/{orderId}/rejectOrder',
                getStateByCountryOrder:  sitePath + '/order/getstatebycountry',
                updateCdChecks:  sitePath + '/order/{orderId}/updateCdChecks'
            },
            mergeQuoteResellerSearch: sitePath + '/mergequote/searchreseller',
            mergeQuoteSearchCall: sitePath + '/mergequote/search',
            mergequotestep1: sitePath + '/mergequote',
            mergequotestepcontinue: sitePath + '/mergequote/validate',
            mergequotestep1back: sitePath + '/mergequote/back',
            mergequotestep2overlay: sitePath + '/mergequote/splitOrderTable/',
            mergequotestep2submit: sitePath + '/mergequote/splitOrderSubmit/',
            mergequotestep2quoteSelection: sitePath + '/mergequote/checkQuoteSelection',
            mergequotestep2ConvertOrder: sitePath + '/order/new/mergeQuote/',
            mergequotestep2Get: sitePath + '/mergequote/getSelectedQuotes',
            fetchConfiguratorData: sitePath + '/order/{orderId}/showVpsConfigurator/',
            fetchConfiguratorDataOrder: sitePath + '/quote/showVpsConfigurator/',
            vendor: {
                create: sitePath + '/vendorquote/order',
                referenceNumber: sitePath + '/vendorquote/createOrderFromId',
                file: sitePath + '/vendorquote/createOrderFromBOM'
            },
            merakiMandatoryCheck: sitePath + '/order/merakiMandatoryCheck/{orderNumer}'
        },

        toolsstorefront: {
            submitDefaults: sitePath + '/sovat/setDefaults',
            submitVatDetailsToSAP: sitePath + '/sovat/fetchVAT'
        }
    }
};

/**
 * Bundles Types
 */
globals.bundles = {
    TOPDOWN_PARENT_BUNDLE_TYPE: 'TPB',
    TOPDOWN_CHILD_BUNDLE_TYPE: 'TCB',
    ROLLUP_PARENT_BUNDLE_TYPE: 'RPB',
    ROLLUP_CHILD_BUNDLE_TYPE: 'RCB',
    VENDOR_PARENT_TYPE: 'VIP',
    VENDOR_CHILD_TYPE: 'VIC',
    STANDARD_TYPE: 'STD',
    TECEX_TYPE: 'TECEX',
    CISCO_PARENT_TYPE: 'VPSP',
    CISCO_CHILD_TYPE: 'VPSC',
    AVAYA_CLOUD_TYPE: 'SUBSCRIPTION',
    CISCO_FULL_TERM_ITEM: 'FULL_TERM_ITEM',
    BLUE_SKY_TYPE: 'CONFIGURABLE',
    BLUE_SKY_PARENT_TYPE: 'CONFIGURED_PARENT',
    BLUE_SKY_CHILD_TYPE: 'CONFIGURED_CHILD',
    CREDIT_TYPE: 'CREDITLINE',
    EXPANDED_TYPE: 'EXPANDED',
    CONSOLIDATED_TYPE: 'CONSOLIDATED'
};

globals.partno='Partnumber';
globals.partnoQty='Part number + Qty';
globals.partnoQtyVdGp='Part number + Qty + VendorDiscount% + GlobalPoints%';
globals.partnoQtyVdRe='Part number + Qty + VendorDiscount% + ResellerPriceOffList%';
globals.partnoQtyVdRp='Part number + Qty + VendorDiscount% + ResellerPrice$$';
globals.partnoQtyWcGp='Part number + Qty + WestconCost$$ + GlobalPoints%';
globals.partnoQtyWcRe='Part number + Qty + WestconCost$$ + ResellerPriceOffList%';
globals.partnoQtyWcRp='Part number + Qty + WestconCost$$ + ResellerPrice$$';
globals.partnoQtyLpWcRp='Part number + Qty + ListPrice$$ + WestconCost$$ + ResellerPrice$$';
globals.partnoQtyLpWcRpIn='Part number + Qty + ListPrice$$ + WestconCost$$ + ResellerPrice$$ + ItemNotes';
globals.partnoQtyVd='Part number + Qty + VendorDiscount%';
globals.partnoQtyWc='Part number + Qty + WestconCost$$';
globals.partnoQtyGp='Part number + Qty + GlobalPoints%';
globals.partnoQtyRe='Part number + Qty + ResellerPriceOffList%';
globals.partnoQtyRp='Part number + Qty + ResellerPrice$$';
globals.partnoQtyRpIn='Part number + Qty + ResellerPrice$$ + ItemNotes';
globals.partnoQtyLpVd='Part number + Qty + Listprice$$ + VendorDiscount%';
globals.partnoQtyIn='Part number + Qty + ItemNotes';

globals.readonly = {
    parentTopDownReadOnlyCells: [
        'displayEntryNumber',
        'description',
        'parentEntryNumber',
        'listPrice',
        'purchaseDiscount',
        'purchasePrice',
        'extendedCost',
        'intrlPrice',
        'fxRate',
        'manualItemCategory',
        'pricingCondition',
        'duration',
        'durationUnit',
        'plant',
        'weight',
        'volume',
        'productHierarchy',
        'SBA',
        'VRF',
        'desiredVendor',
        'cntrtStartDate',
        'cntrtEndDate',
        'deliveryGroup'
    ],

    parentChildTopDownReadOnlyCells: [
        'displayEntryNumber',
        'description',
        'parentEntryNumber',
        'listPrice',
        'purchaseDiscount',
        'purchasePrice',
        'extendedCost',
        'intrlPrice',
        'fxRate',
        'manualItemCategory',
        'pricingCondition',
        'duration',
        'durationUnit',
        'plant',
        'weight',
        'volume',
        'productHierarchy',
        'SBA',
        'desiredVendor',
        'cntrtStartDate',
        'cntrtEndDate',
        'deliveryGroup',
        'estimatedFreight'
    ],

    tecexReadOnlyCells: [
        'partNo',
        'displayEntryNumber',
        'description',
        'handlingUnitVAS',
        'customerPartNumber',
        'parentEntryNumber',
        'listPriceInQuoteCurrency',
        'purchasePriceInQuoteCurrency',
        'extendedCostInQuoteCurrency',
        'listPrice',
        'purchaseDiscount',
        'purchasePrice',
        'extendedCost',
        'intrlPrice',
        'fxRate',
        'marginGPL',
        'margin',
        'resellerPercentage',
        'extendedPrice',
        'vatPercentage',
        'pricingCondition',
        'duration',
        'durationUnit',
        'plant',
        'weight',
        'volume',
        'productHierarchy',
        'availability',
        'shipDate',
        'deliveryBlockCode',
        'billingBlockCode',
        'SBA',
        'VRF',
        'desiredVendor',
        'cntrtStartDate',
        'cntrtEndDate',
        'deliveryGroup',
        'availabilityinSelectedPlant',
        'itemCategory',
        'manualItemCategory'
    ],

    parentRollUpReadOnlyCells: [
        'displayEntryNumber',
        'description',
        'parentEntryNumber',
        'listPrice',
        'purchaseDiscount',
        'purchasePrice',
        'extendedCost',
        'intrlPrice',
        'fxRate',
        'marginPercentage',
        'marginGPL',
        'margin',
        'resellerPrice',
        'resellerPercentage',
        'extendedPrice',
        'vatPercentage',
        'manualItemCategory',
        'pricingCondition',
        'duration',
        'weight',
        'volume',
        'productHierarchy',
        'SBA',
        'VRF',
        'desiredVendor',
        'cntrtStartDate',
        'cntrtEndDate',
        'deliveryGroup'
    ],

    parentChildRollUpReadOnlyCells: [
        'displayEntryNumber',
        'description',
        'parentEntryNumber',
        'listPrice',
        'purchaseDiscount',
        'purchasePrice',
        'extendedCost',
        'intrlPrice',
        'fxRate',
        'marginPercentage',
        'marginGPL',
        'margin',
        'resellerPrice',
        'resellerPercentage',
        'extendedPrice',
        'vatPercentage',
        'manualItemCategory',
        'pricingCondition',
        'duration',
        'weight',
        'volume',
        'productHierarchy',
        'SBA',
        'desiredVendor',
        'cntrtStartDate',
        'cntrtEndDate',
        'deliveryGroup'
    ],

    childTopDownReadOnlyCells: [
        'displayEntryNumber',
        'partNo',
        'handlingUnitVAS',
        'quantity',
        'description',
        'parentEntryNumber',
        'listPrice',
        'purchaseDiscount',
        'intrlPrice',
        'fxRate',
        'marginPercentage',
        'marginGPL',
        'margin',
        'resellerPrice',
        'resellerPercentage',
        'extendedPrice',
        'vatPercentage',
        'pricingCondition',
        'availability',
        'plant',
        'durationUnit',
        'shipDate',
        'productHierarchy',
        'deliveryBlockCode',
        'billingBlockCode',
        'weight',
        'volume',
        'desiredVendor',
        'groupId',
        'groupDescription'
    ],
    childRollUpReadOnlyCells: [
        'displayEntryNumber',
        'partNo',
        'handlingUnitVAS',
        'customerPartNumber',
        'quantity',
        'description',
        'parentEntryNumber',
        'listPriceInQuoteCurrency',
        'purchasePriceInQuoteCurrency',
        'extendedCostInQuoteCurrency',
        'intrlPrice',
        'fxRate',
        'pricingCondition',
        'availability',
        'plant',
        'durationUnit',
        'shipDate',
        'productHierarchy',
        'deliveryBlockCode',
        'billingBlockCode',
        'weight',
        'volume',
        'desiredVendor',
        'groupId',
        'groupDescription'
    ],
    stdReadOnlyCells: [
        'displayEntryNumber',
        'description',
        'parentEntryNumber',
        'intrlPrice',
        'fxRate',
        'pricingCondition',
        'availability',
        'productHierarchy',
        'availabilityinSelectedPlant'
    ],

    supportLineParent: [
        'listPrice',
        'purchaseDiscount',
        'purchasePrice',
        'extendedCost'
    ],

    stdCrossCellsReadOnlyCells:[
        'partNo',
        'customerPartNumber',
        'quantity',
        'displayEntryNumber',
        'description',
        'parentEntryNumber',
        'intrlPrice',
        'fxRate',
        'pricingCondition',
        'availability',
        'productHierarchy'
    ],

    ciscoReadOnlyCells: [
        'listPrice',
        'quantity',
        'purchaseDiscount',
        'purchasePrice',
        'extendedCost',
        'intrlPrice',
        'duration',
        'plant',
        'itemCategory',
        'manualItemCategory'
    ],

    avayaChildReadOnlyCells: [
        'listPrice',
        'quantity',
        'purchaseDiscount',
        'description',
        'purchasePrice',
        'extendedCost',
        'duration',
        'plant',
        'itemCategory',
        'manualItemCategory'
    ],

    avayaCloudReadOnlyCells: [
        'quantity',
        'listPrice',
        'description',
        'purchaseDiscount',
        'purchasePrice',
        'extendedCost',
        'intrlPrice',
        'duration',
        'itemCategory',
        'manualItemCategory',
        'productHierarchy'
    ],

    supportChildReadOnlyCells: [
        'entryType',
        'globalPoints',
        'cntrtStDate',
        'cntrtEndDate',
        'optionalAlternativePartExtendedPrice',
        'optionalAlternativePartUnitPrice'
    ],

    configuratorChildReadOnlyCells: [
        'blueSkyConfigurator'
    ],

    blueSkyReadOnlyCells: [
        'referenceNumber',
        'extCustomerPartNumber',
        'custLineNum',
        'exceptionReason'
    ]
};
